<app-dialog-container
  title="{{ 'copyComponents' | translate }}"
  [isValid]="form.valid"
  (confirmButtonHandler)="save()"
>
  <form [formGroup]="form">
    <div>
      <app-ui-select
        label="{{ 'tenant' | translate }}"
        [control]="form.targetTenantId"
        [options]="allTenants"
        [isMultiple]="false"
        (changeHandler)="onTargetTenantChange()"
      ></app-ui-select>
      <app-ui-select
        label="{{ 'departments' | translate }}"
        [control]="form.targetDepartmentIds"
        [options]="allDepartments"
        [isMultiple]="true"
      ></app-ui-select>

      <div class="row-container">
        <app-ui-slide-toggle
          label="{{ 'copyContents' | translate }}"
          [control]="form.copyContents"
          (changeHandler)="onCopyContentsChange()"
        ></app-ui-slide-toggle>
        <mat-icon
          [class.access-tooltip-icon-disabled]="form.disabled"
          [attr.aria-label]="'copyContents' | translate"
          [matTooltip]="'copyContentsDescription' | translate"
        >
          help_outlined
        </mat-icon>
      </div>
      @if (form.copyContents.value) {
        <app-ui-select
          label="{{ 'copyMode' | translate }}"
          [control]="form.copyMode"
          [options]="allCopyModes"
          [isMultiple]="false"
        ></app-ui-select>
        <div class="copy-mode-description">
          <h3>
            {{ 'copyModeHeader' | translate }}
          </h3>
          <ul>
            <li>
              <b>{{ 'FullTransfer' | translate }}:</b>
              {{ 'copyModeFullTransfer' | translate }}
            </li>
            <li>
              <b>{{ 'Template' | translate }}:</b>
              {{ 'copyModeTemplate' | translate }}
            </li>
          </ul>
        </div>
      }
    </div>
  </form>
</app-dialog-container>
